const extractQuestionsFromPageResponse = (pageResponse) => {
  const questions = [];
  (pageResponse.page.questionGroups || []).map( group => {
    (group.questions || []).map( q => questions.push(q) );
  });
  return questions;
};

export default extractQuestionsFromPageResponse;
